import querystring from 'querystring'

function fetchInternal(url, data, method, headers) {
    return fetch(url, {
        method: method,
        credentials: 'include',
        headers: new Headers(headers),
        body: JSON.stringify(data)
    }).then(checkStatus)
}

export const checkStatus = response => {
    if (!response.ok) {
        const error = new Error(response.statusText)
        error.response = response
        throw error
    }
    return response
}

export const fetchApi = (url, data, method = 'GET', fetchFunction = fetchInternal) => {
    const headers = {
        "Cache": "no-cache",
        "pragma": "no-cache",
        "Accept": "application/json",
        "Content-Type": "application/json",
    }
    return fetchFunction(url, data, method, headers)
}

export const fetchApiPdf = (url, data, method = 'GET', fetchFunction = fetchInternal) => {
    const headers = {
        "Cache": "no-cache",
        "pragma": "no-cache",
        "Accept": "application/pdf",
        "Content-Type": "application/pdf"
    }
    return fetchFunction(url, data, method, headers)
}

export const fetchApiZip = (url, data, method = 'GET', fetchFunction = fetchInternal) => {
    const headers = {
        "Cache": "no-cache",
        "pragma": "no-cache",
        "Accept": "application/zip",
        "Content-Type": "application/zip"
    }
    return fetchFunction(url, data, method, headers)
}

export const fetchApiBlob = (url, data, method = 'GET', fetchFunction = fetchInternal) => {
    const headers = {
        "Cache": "no-cache",
        "pragma": "no-cache",
        "Accept": "application/octet-stream",
        "Content-Type": "application/octet-stream"
    }

    return fetchFunction(url, data, method, headers)
}

export const fetchApiAuthentication = (url, data, CSRFToken, method = 'POST', fetchFunction = fetchInternal) => {
    const headers = {
        "CSRF-Token": CSRFToken,
        "pragma": "no-cache",
        "Cache": "no-cache",
        "Accept": "application/json",
        "Content-Type": "application/json"
    }
    let queryParams = querystring.stringify({
        username: data.username,
        password: data.password
    })

    return fetchFunction(url + "?" + queryParams, undefined, method, headers)
}


// WEBPACK FOOTER //
// ./src/shared/actions/fetchApi.js